import React from 'react';
import { withNamespaces } from 'react-i18next';
import { getAllListsPage, sortList, sortListByCode, addLeaveRequest, addVacationRequest } from '../../actions/request';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import i18next from 'i18next';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { IsEnglish } from '../../utils/language';
import LeaveRequestForm from './LeaveRequestForm';
import VacationRequestForm from './VacationRequestForm';
import Button from 'react-bootstrap-button-loader';
import { formatDate } from '../../utils';
import * as requestTypeCode from '../../scripts/RequestTypeCode';
import * as durationType from '../../scripts/DurationTypeCode';
import * as storage from '../../utils/storage';
import AlertAlgo from '../controls/AlertSnack';

import styles from '../../styles/request.module.css';


class RequestForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            requestTypeList: null,
            payCodeList: null,
            requestType: null,
            isActive: true,
            isPostCompleted: true,

            // General
            isPartial: false,
            startDate: null,
            endDate: null,
            returnDate: null,
            duration: null,
            comment: null,
            startTime: null,
            endTime: null,
            // Leave
            payCode: null,

            // Vacation
            payAdvance: false,
            datePay: null
        }

        this.alert = React.createRef();
    }

    componentDidMount() {
        this.initPage();
        this.resizeForm();
    }

    resizeForm() {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('div[data-id=headerRequest]').offsetHeight;
            const offSet = 50;

            const customHeight = height - header - titleBar - offSet;

            const element = document.querySelector('#divForm');

            if (element !== null) {
                element.style.height = `${customHeight}px`;
                element.style.overflowX = 'hidden';
            }
        }, 1000);
    }

    initPage = async () => {
        const result = await getAllListsPage();

        // We're going to activate only vacation and leave
        const requestTypeList = result.requestTypeList.filter(item => item.value == 4 || item.value == 5);

        this.setState({
            requestTypeList: sortList(requestTypeList),
            payCodeList: sortListByCode(result.payCodeList),
            isActive: false
        })
    }

    onChangeRequestType = (event) => {
        this.setState({ requestType: parseInt(event.target.value) });
    }

    onChangeLeaveRequestForm = (startDate, endDate, returnDate, payCode, isPartial, duration, comment, startTime, endTime) => {
        this.setState({
            startDate: startDate,
            endDate: endDate,
            returnDate: returnDate,
            payCode: payCode,
            isPartial: isPartial,
            duration: duration,
            comment: comment,
            startTime: startTime,
            endTime: endTime
        });
    }

    onChangeVacationRequestForm = (startDate, endDate, returnDate, isPartial, duration, payAdvance, datePay, comment, startTime, endTime) => {
        this.setState({
            startDate: startDate,
            endDate: endDate,
            returnDate: returnDate,
            isPartial: isPartial,
            duration: duration,
            payAdvance: payAdvance,
            datePay: datePay,
            comment: comment,
            startTime: startTime,
            endTime: endTime
        });
    }

    handleSaveClick = async () => {
        this.setState({ isPostCompleted: false });

        const isValid = await this.validateForm();

        if (isValid) {
            const result = await this.saveForm()
                .catch(error => {
                    this.showMessageError(i18next.t('error:generic-error'));
                    this.setState({ isPostCompleted: true });
                });

            if (result) {
                this.showMessageSuccess(i18next.t('request:message.success'));
                this.resetForm();
                this.setState({ isPostCompleted: true });
            } else {
                this.setState({ isPostCompleted: true });
            }
        }
        else {
            this.setState({ isPostCompleted: true });
        }
    }

    showMessageSuccess = (msg) => {
        this.alert.current.showMessageSuccess(msg);
    }

    showMessageError = (msg) => {
        this.alert.current.showMessageError(msg);
    }

    saveForm = () => {
        return new Promise(async (resolve, reject) => {
            let result = false;
            let resultSave = [];

            if (this.state.requestType === requestTypeCode.Type_Leave) {
                resultSave = await addLeaveRequest(this.state.startDate, this.state.endDate, durationType.Type_Hour, parseFloat(this.state.duration), this.state.comment, this.state.isPartial, this.state.payCode, this.state.returnDate, this.state.startTime, this.state.endTime);
            } else if (this.state.requestType === requestTypeCode.Type_Vacation) {
                const datePay = this.state.datePay != null ? formatDate(new Date(this.state.datePay.replace('-', '/')), 'date') : null;
                resultSave = await addVacationRequest(this.state.startDate, this.state.endDate, durationType.Type_Hour, this.state.duration !== null ? parseFloat(this.state.duration) : null, this.state.comment, this.state.isPartial, this.state.payAdvance, datePay, this.state.returnDate, this.state.startTime, this.state.endTime);
            }

            if (resultSave === undefined) {
                reject("resultSave = undefined");
                return;
            }

            result = resultSave.success;

            if (result != null) {
                await this.validateFormResult(resultSave.message);
            }

            resolve(result);
        })
    }

    validateFormResult = (messages) => {
        return new Promise(resolve => {
            let message = '';

            messages != null && messages.forEach((item, index) => {
                message += (index > 0 ? '\n' : '') + item;
            });

            this.showMessageError(message);

            resolve();
        })
    }

    validateForm = () => {
        return new Promise(async (resolve) => {
            let result = false;

            if (this.state.requestType === requestTypeCode.Type_Leave) {
                result = await this.validateLeave();
            } else if (this.state.requestType === requestTypeCode.Type_Vacation) {
                result = await this.validateVacation();
            }

            resolve(result);
        })
    }

    validateLeave = () => {
        return new Promise(resolve => {
            let message = '';
            let error = false;

            if (this.state.startDate === null) {
                message = i18next.t('request:message.startDate-form');
                error = true;
            } else if (this.state.endDate === null && !this.state.isPartial) {
                message = i18next.t('request:message.endDate-form');
                error = true;
            } else if (this.state.endDate < this.state.startDate && !this.state.isPartial) {
                message = i18next.t('request:message.intervalDate-form');
                error = true;
            } else if ((storage.getScheduleReturnDate() && this.state.returnDate !== null) && this.state.returnDate < this.state.startDate) {
                message = i18next.t('request:message.returnDate-form');
                error = true;
            } else if (this.state.payCode === null) {
                message = i18next.t('request:message.payCode-form');
                error = true;
            } else if (this.state.duration <= 0 && this.state.isPartial) {
                message = i18next.t('request:message.duration-form');
                error = true;
            }

            if (error) {
                this.showMessageError(message);
            }

            resolve(!error);
        });
    }

    validateVacation = () => {
        return new Promise(resolve => {
            let message = '';
            let error = false;

            if (this.state.startDate === null) {
                message = i18next.t('request:message.startDate-form');
                error = true;
            } else if (this.state.endDate === null && !this.state.isPartial) {
                message = i18next.t('request:message.endDate-form');
                error = true;
            } else if (this.state.endDate < this.state.startDate && !this.state.isPartial) {
                message = i18next.t('request:message.intervalDate-form');
                error = true;
            } else if ((storage.getScheduleReturnDate() && this.state.returnDate !== null) && this.state.returnDate < this.state.startDate) {
                message = i18next.t('request:message.returnDate-form');
                error = true;
            } else if (this.state.duration <= 0 && this.state.isPartial) {
                message = i18next.t('request:message.duration-form');
                error = true;
            } else if (this.state.payAdvance && this.state.datePay === null) {
                message = i18next.t('request:message.advancedPay-form');
                error = true;
            }

            if (error) {
                this.showMessageError(message);
            }

            resolve(!error);
        });
    }

    resetForm = () => {
        this.setState({
            requestType: null,
            isPostCompleted: true,

            // General
            isPartial: false,
            startDate: null,
            endDate: null,
            returnDate: null,
            duration: null,
            comment: null,

            // Leave
            payCode: null,

            // Vacation
            payAdvance: false,
            datePay: null
        });
    }

    render() {
        const { t } = this.props;

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('request:form.loading')}
            >
                <div id="divForm" className={styles.divForm}>
                    <FormControl fullWidth className={styles.divTypeRequest}>
                        <div className={styles.divFormSelect}>
                            <InputLabel id="label-requestType">{t('request:form.requestType')}</InputLabel>
                            <Select
                                labelId="label-requestType"
                                id="requestType"
                                value={this.state.requestType || ''}
                                onChange={this.onChangeRequestType}
                                className={styles.divFullWidth}
                            >
                                {this.state.requestTypeList && this.state.requestTypeList.map((obj, index) =>
                                    <MenuItem key={index} className={styles.selectItem} value={obj.value}>{`${IsEnglish() ? obj.descriptionEn : obj.descriptionFr}`}</MenuItem>
                                )}
                            </Select>
                        </div>
                    </FormControl>

                    {this.state.requestType === requestTypeCode.Type_Leave && <LeaveRequestForm payCodeList={this.state.payCodeList} onChange={this.onChangeLeaveRequestForm} />}
                    {this.state.requestType === requestTypeCode.Type_Vacation && <VacationRequestForm payCodeList={this.state.payCodeList} onChange={this.onChangeVacationRequestForm} />}

                    {this.state.requestType > 0 && <FormControl fullWidth className={styles.divSaveButtonRequest}>
                        <Button
                            loading={!this.state.isPostCompleted}
                            className="saveButton"
                            onClick={this.handleSaveClick}
                            variant="success"
                        >
                            {i18next.t('request:button.save')}
                        </Button>
                    </FormControl>}

                    <AlertAlgo ref={this.alert} />
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['request', 'error'], { wait: true })(RequestForm);